import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const bargaining_apis = API_URLs.bargaining;

export const apiCall_getbargainings = async () => {
  return http.get(bargaining_apis.getBargainingsList);
};

export const apiCall_confirmBargaining = async (ProposalId) => {
  return http.post(
    bargaining_apis.confirmBargaining + "?ProposalId=" + ProposalId
  );
};

export const apiCall_rejectBargaining = async (ProposalId) => {
  return http.post(
    bargaining_apis.rejectBargaining + "?ProposalId=" + ProposalId
  );
};

export const apiCall_reviseBargaining = async ({
  ProposalId,
  Quantity,
  Price,
}) => {
  return http.post(
    bargaining_apis.reviseBargaining +
      `?ProposalId=${ProposalId}&Quantity=${Quantity}&Price=${Price}`
  );
};
